import { IMutationProps } from '../../../interfaces/ui';
import { useMutationWithResultNotification } from '../useMutationWithResultNotification';
import { ICreateCaseConversationSchedule } from '../../../interfaces/conversationSchedules';
import { createMultipleCaseConversationSchedule } from '../../conversationSchedules';
import {
  displayErrorArrayNotificationsWithoutTranslations,
  displayErrorNotification,
  displaySuccessNotification,
} from '../../../modules/Notifications';
import { IErrorDefinition } from '../../../interfaces/response';

type useCreateMultipleCaseConversationScheduleParams = {
  organizationId: string;
  caseId: string;
};

const useCreateMultipleCaseConversationSchedule = (
  params: useCreateMultipleCaseConversationScheduleParams,
  options: IMutationProps
) => {
  return useMutationWithResultNotification({
    asyncApiFunction: async (data: ICreateCaseConversationSchedule[]) => {
      await createMultipleCaseConversationSchedule(
        params.organizationId,
        params.caseId,
        data
      );
    },
    onSuccess: () => {
      displaySuccessNotification(
        'Api.Mutations.ConversationSchedules.CreateCaseConversationSchedule.success'
      );

      if (options.successFb) options.successFb();
    },
    onErrorArray: (errors: IErrorDefinition[]) => {
      displayErrorNotification(
        'Api.Mutations.ConversationSchedules.CreateCaseConversationSchedule.failure'
      );

      displayErrorArrayNotificationsWithoutTranslations(errors);

      if (options.errorFb) options.errorFb();
    },
    resetOnResult: true,
  });
};

export default useCreateMultipleCaseConversationSchedule;
